<template>
    <section>
        <div class="columns">
            <div class="column">
                <div class="title is-5 has-text-centered">
                    Tabla de Procesos de Convenios de Desempeño
                    <hr class="dropdown-divider" aria-role="menuitem">
                </div>
            </div>
        </div>

        <b-table :data="process" paginated per-page=10 :pagination-simple=false pagination-position="bottom"
            aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Página"
            aria-current-label="Página actual">
            <b-table-column label="Año" field="year" sortable v-slot="props">
                {{ props.row.year }}
            </b-table-column>

            <b-table-column label="Fecha Inicio" field="start_date" sortable v-slot="props">
                {{ props.row.start_date._isValid ? new Date(props.row.start_date).toLocaleDateString("es-CL") : ''
                }}
            </b-table-column>

            <b-table-column label="Última Fase" field="phase_d_type.alt_name" sortable v-slot="props">
                {{ props.row.phase_d_type.alt_name }}
            </b-table-column>

            <b-table-column label="Acciones" width="10%" v-slot="props">
                <b-button label="Ver Proceso" type="is-primary" icon-left="eye" tag="a"
                    :href="`/performance_phases/process/${props.row.year}/unit/${unit.id}`" target="_blank" />
            </b-table-column>
            <template slot="empty" slot-scope="props">
                <div class="columns is-centered">
                    <div class="column is-6 is-centered has-text-centered">
                        <b-message type="is-warning">
                            Aún no se ha dado inicio a un Proceso de Declaración de Convenios de Desempeño.
                        </b-message>
                    </div>
                </div>
            </template>
        </b-table>

        <b-loading is-full-page v-model="isLoading" />
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
export default {

    name: 'UnitProcess',

    props: {
        unit: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            //Auxiliares
            isLoading: false,

            //Datos
            process: [],
        }
    },

    async created() {
        await this.getProcess();
    },

    methods: {
        async getProcess() {
            this.isLoading = true;
            await axios
                .get('/performance_phases.json')
                .then(response => {
                    this.process = response.data;
                    this.process.forEach(element => {
                        element.start_date = moment(element.start_date, ["YYYY-MM-DD", "DD-MM-YYYY"])
                        element.end_date = moment(element.end_date, ["YYYY-MM-DD", "DD-MM-YYYY"])
                    });
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al traer la información de los Procesos. Intente más tarde',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },

}
</script>